import { fetcher } from 'services/helpers/responseHandler'

const makePayment = data => {
  // TODO(bartu): Remove this when we have a proper backend handler
  if (data.PaymentMethod === 'CreditCard') {
    return fetcher.post('billing/payment/add/credit-card', data)
  }

  return fetcher.post('billing/payment/add', data)
}

const addACHCredit = ({ creditAmount, note, adviceNumber, invoiceIds }) =>
  fetcher.post('billing/payment/add/ach-credit', {
    creditAmount,
    note,
    adviceNumber,
    invoiceIds
  })

const addPaymentAccount = data => fetcher.post('billing/payment/account/add', data)

const makeInitialPayment = data => fetcher.post('billing/payment/initial-payment', data)

const paymentApi = {
  makePayment,
  addPaymentAccount,
  makeInitialPayment,
  addACHCredit
}

export default paymentApi
